module.exports = __webpack_public_path__ + "static/media/closedoublequotes.c6103df2.svg";